import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { BLOCKS, MARKS } from "@contentful/rich-text-types";

import { richContentOptions } from "@/components/content-options";

const B = (text) => <strong className="font-medium text-black">{text}</strong>;

const H6 = (node, children) => (
  <h6 className="text-sm font-medium text-brand-600">{children}</h6>
);

const P = (node, children) => {
  return <p className="mt-3 text-base text-gray-500">{children}</p>;
};

export default function Content({ fields, first = false, sys }) {
  const options = {
    ...richContentOptions,
    renderMark: {
      ...richContentOptions.renderMark,
      [MARKS.BOLD]: B,
    },
    renderNode: {
      ...richContentOptions.renderNode,
      [BLOCKS.HEADING_6]: H6,
      [BLOCKS.PARAGRAPH]: P,
    },
  };

  let modelsSection = {
    content: fields.content.content.slice(
      fields.content.content
        .map((item) => {
          return item?.content[0]?.value;
        })
        .indexOf("Models")
    ),
    data: fields.content.data,
    nodeType: fields.content.nodeType,
  };

  let beforeModelsSection = {
    content: fields.content.content.slice(
      0,
      fields.content.content
        .map((item) => {
          return item?.content[0]?.value;
        })
        .indexOf("Models")
    ),
    data: fields.content.data,
    nodeType: fields.content.nodeType,
  };

  const Title = ({ text }) => {
    return first ? (
      <h1 className="mb-2 block text-3xl text-center leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
        {text}
      </h1>
    ) : (
      <h3 className="mb-2 block text-3xl text-center leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
        {text}
      </h3>
    );
  };

  return (
    <div className="relative py-16 bg-white overflow-hidden">
      <div className="hidden lg:block lg:absolute lg:inset-y-0 lg:h-full lg:w-full">
        <div
          className="relative h-full text-lg max-w-prose mx-auto"
          aria-hidden="true"
        >
          <svg
            className="absolute top-12 left-full transform translate-x-32"
            width="404"
            height="384"
            fill="none"
            viewBox="0 0 404 384"
          >
            <defs>
              <pattern
                id="74b3fd99-0a6f-4271-bef2-e80eeafdf357"
                x="0"
                y="0"
                width="20"
                height="20"
                patternUnits="userSpaceOnUse"
              >
                <rect
                  x="0"
                  y="0"
                  width="4"
                  height="4"
                  className="text-gray-200"
                  fill="currentColor"
                />
              </pattern>
            </defs>
            <rect
              width="404"
              height="384"
              fill="url(#74b3fd99-0a6f-4271-bef2-e80eeafdf357)"
            />
          </svg>
          <svg
            className="absolute top-1/2 right-full transform -translate-y-1/2 -translate-x-32"
            width="404"
            height="384"
            fill="none"
            viewBox="0 0 404 384"
          >
            <defs>
              <pattern
                id="f210dbf6-a58d-4871-961e-36d5016a0f49"
                x="0"
                y="0"
                width="20"
                height="20"
                patternUnits="userSpaceOnUse"
              >
                <rect
                  x="0"
                  y="0"
                  width="4"
                  height="4"
                  className="text-gray-200"
                  fill="currentColor"
                />
              </pattern>
            </defs>
            <rect
              width="404"
              height="384"
              fill="url(#f210dbf6-a58d-4871-961e-36d5016a0f49)"
            />
          </svg>
          <svg
            className="absolute bottom-12 left-full transform translate-x-32"
            width="404"
            height="384"
            fill="none"
            viewBox="0 0 404 384"
          >
            <defs>
              <pattern
                id="d3eb07ae-5182-43e6-857d-35c643af9034"
                x="0"
                y="0"
                width="20"
                height="20"
                patternUnits="userSpaceOnUse"
              >
                <rect
                  x="0"
                  y="0"
                  width="4"
                  height="4"
                  className="text-gray-200"
                  fill="currentColor"
                />
              </pattern>
            </defs>
            <rect
              width="404"
              height="384"
              fill="url(#d3eb07ae-5182-43e6-857d-35c643af9034)"
            />
          </svg>
        </div>
      </div>
      <div className="relative px-4 sm:px-6 lg:px-8">
        <div className="text-lg max-w-prose mx-auto">
          {fields.title && <Title text={fields.title} />}
          {fields.highlight && (
            <p className="block text-base text-center text-brand-600 font-semibold tracking-wide uppercase">
              {fields.highlight}
            </p>
          )}
        </div>
        {fields.content && (
          <div className="mt-12 prose prose-brand prose-lg text-gray-500 mx-auto">
            {documentToReactComponents(beforeModelsSection, options)}
          </div>
        )}

        {fields.content && (
          <div
            id="models"
            className="mt-12 prose prose-brand prose-lg text-gray-500 mx-auto"
          >
            {documentToReactComponents(modelsSection, options)}
          </div>
        )}
      </div>
    </div>
  );
}
